import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  name: "",
  email: "",
  avatar: "",
  token: ""
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      return { ...state, ...action.payload };
    },
    logoutUser() {
      return initialState;
    }
  }
});

export const { setUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;
